// extracted by mini-css-extract-plugin
export default {"labelPergunta":"LabelPergunta_labelPergunta__D6I19","cinza":"LabelPergunta_cinza__YxJmi","azul":"LabelPergunta_azul__zkZdx","required":"LabelPergunta_required__G7St2"};